var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"37cf86358df151155f00502984a870d3d4dd1261"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nmh@try-apt-as"]={id:"37cf86358df151155f00502984a870d3d4dd1261"};
      